import { animate, AnimationBuilder, AnimationMetadata, AnimationPlayer, style } from '@angular/animations';
import { Directive, ElementRef } from '@angular/core';
import { HostListener } from '@angular/core';

@Directive({
  selector: '[appFadeIntoView]',
})
export class FadeIntoViewDirective {

  private element: ElementRef;
  private animationPlayer: AnimationPlayer;
  private isElementScrolledIntoView = false;
  private isElementScrolledOutOfView = false;
  isAnimated = false;

  @HostListener('window:scroll', ['$event'])
  isScrolledIntoView() {
    if (this.element && !this.isAnimated) {
      const rect = this.element.nativeElement.getBoundingClientRect();
      const topShown = rect.top < window.innerHeight && rect.top >= (window.innerHeight / 2);
      // const bottomShown = rect.bottom <= window.innerHeight;
      const bottomInView = rect.bottom <= window.innerHeight && rect.bottom > 0
      const isAlreadyInView = this.isElementScrolledIntoView;
      const isAlreadyOutOfView = this.isElementScrolledOutOfView;
      this.isElementScrolledIntoView = topShown || bottomInView;
      this.isElementScrolledOutOfView = rect.top <= 0 && rect.bottom <= 0;
      // if (this.isElementScrolledOutOfView) console.log(rect.top, rect.bottom, isAlreadyOutOfView, this.isElementScrolledOutOfView);
      if (!isAlreadyInView) {
        if (this.isElementScrolledIntoView) {
          // console.log(rect.top, rect.bottom, rect.height);
          // console.log(isAlreadyInView, this.isElementScrolledIntoView);
          this.animateEl();
        }
      }
      if (!isAlreadyOutOfView) {
        if (this.isElementScrolledOutOfView) {
          // console.log(rect.top, rect.bottom, rect.height);
        }
      }
    }
  }
  
  constructor(private el: ElementRef, private builder: AnimationBuilder) {
    this.element = el;
    const factory = this.builder.build(this.fadeIn());
    this.animationPlayer = factory.create(this.element.nativeElement);
    this.element.nativeElement.setAttribute('style', 'opacity: 0; transform: translateY(30px) scale(0.5)');
  }

  private animateEl() {
    this.animationPlayer.play();
    this.isAnimated = true;
  }

  private fadeIn(): AnimationMetadata[] {
    return [
      style({ opacity: 0, transform: 'translateY(30px) scale(0.5)' }),
      animate('400ms ease-in', style({ opacity: 1, transform: 'translateY(0) scale(1)' })),
    ];
  }

}
